import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OrderingService {
  handleOrderingChange(ordering: string[], field: string) {
    const fieldIndex = this.getFieldOrderingIndex(ordering, field);
    const reverseFieldIndex = this.getFieldOrderingIndex(ordering, `-${field}`);

    if (fieldIndex !== -1) {
      ordering.splice(fieldIndex, 1);
      ordering.unshift(`-${field}`);
    } else if (reverseFieldIndex !== -1) {
      ordering.splice(reverseFieldIndex, 1);
      if (reverseFieldIndex !== 0) {
        ordering.unshift(field);
      }
    } else {
      ordering.unshift(field);
    }
    ordering.splice(3);
  }

  isFieldInOrdering(ordering: string[], field: string) {
    return ordering.includes(field);
  }

  getFieldOrderingIndex(ordering: string[], field: string) {
    return ordering.indexOf(field);
  }

  getOrderingValue(ordering: string[]): string {
    return ordering.join(',');
  }
}
